"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _elements = require("../../elements");

var _utils = require("../../utils");

var styles = {
  "select-wrapper": "select-select-wrapper-3xVb5",
  "focused": "select-focused-3ml6f",
  "select-menu": "select-select-menu-EjIta",
  "option": "select-option-1DSs2",
  "option-icon": "select-option-icon-2R8pK",
  "option-selected": "select-option-selected-20QDg",
  "option-value": "select-option-value-1vWUd",
  "prepend-icon": "select-prepend-icon-2D41_",
  "clear-out-button": "select-clear-out-button-1XORg",
  "show": "select-show-3H16k",
  "pure": "select-pure-2Pasv",
  "selectWrapper": "select-select-wrapper-3xVb5",
  "selectMenu": "select-select-menu-EjIta",
  "optionIcon": "select-option-icon-2R8pK",
  "optionSelected": "select-option-selected-20QDg",
  "optionValue": "select-option-value-1vWUd",
  "prependIcon": "select-prepend-icon-2D41_",
  "clearOutButton": "select-clear-out-button-1XORg"
};

var Option = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _classNames$use;

  var id = _ref.id,
      children = _ref.children,
      selected = _ref.selected,
      icon = _ref.icon,
      className = _ref.className,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["id", "children", "selected", "icon", "className"]);
  return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
    id: id,
    role: "option",
    "aria-selected": selected,
    className: _utils.classNames.use((_classNames$use = {}, (0, _defineProperty2["default"])(_classNames$use, styles.option, true), (0, _defineProperty2["default"])(_classNames$use, styles.optionSelected, selected), _classNames$use)).join(className),
    tabIndex: "-1"
  }, restProps), icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.optionIcon
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    src: icon
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.optionValue
  }, children));
});

Option.propTypes = {
  /* Unique ID of option */
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /* Custom classname applied on option */
  className: _propTypes["default"].string,

  /* Icon to prepend before option value */
  icon: _propTypes["default"].string,

  /* Indicates whether option is selected or not. This props gets overridden
   * by select component
   */
  selected: _propTypes["default"].bool
};
var _default = Option;
exports["default"] = _default;